import type * as React from 'react';

import CommonLayout from '../../../base/components/CommonLayout';
import EcommerceHeader from '../../../base/components/Header/EcommerceHeader';
import { HeaderNoticesPortal } from '../../../base/components/HeaderNotices';
import EditOrderExpirationDialogs from '../../../common/components/molecules/EditOrderDialogs';
import {
    TimeslotExpirationDialog,
    TimeslotMaxOrderTimePassedDialog,
} from '../../../common/components/molecules/TimeslotDialogs';
import { dispatchSetTo } from '../../../common/hooks/useCncFlyInState';
import { useAppDispatch } from '../../../common/hooks/useThunkDispatch';
import { CncStep } from '../../../common/store/structureDefinitions/uiState';

const EcommerceLayout = (props: React.PropsWithChildren) => {
    const dispatch = useAppDispatch();

    const goToTimeslotSelection = () => {
        dispatch(dispatchSetTo({ step: CncStep.TimeSlots }));
    };

    return (
        <CommonLayout>
            <EcommerceHeader hideB2BSwitch={false} />

            <HeaderNoticesPortal />

            {props.children}

            <TimeslotExpirationDialog handleConfirm={goToTimeslotSelection} />
            <TimeslotMaxOrderTimePassedDialog handleConfirm={goToTimeslotSelection} />
            <EditOrderExpirationDialogs />
        </CommonLayout>
    );
};

export default EcommerceLayout;
